"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderRow = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var typestyle_1 = require("typestyle");
var HeaderColumn_1 = require("./HeaderColumn");
var RowHeaderCell_1 = require("./RowHeaderCell");
function getDragIndexFromEvent(e) {
    var dropHeader = e.target.closest('[data-colindex]');
    if (!dropHeader) {
        return -1;
    }
    var dropHeaderRect = dropHeader.getBoundingClientRect();
    var insertAfter = e.clientX - dropHeaderRect.left > dropHeaderRect.width / 2;
    return parseInt(dropHeader.dataset.colindex, 10) + (insertAfter ? 1 : 0);
}
var HeaderRow = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderRow, _super);
    function HeaderRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measuredHeaderWidths = {};
        _this.state = { dragIndex: -1 };
        _this.handleReportHeaderWidth = function (columnKey, width) {
            if (_this.props.measureColumnWidths) {
                _this.measuredHeaderWidths[columnKey] = Math.max(width, _this.measuredHeaderWidths[columnKey] || 0);
            }
        };
        return _this;
    }
    HeaderRow.prototype.componentDidMount = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.componentDidUpdate = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.reportMeasuredColumnWidths = function () {
        if (this.props.measureColumnWidths && Object.keys(this.measuredHeaderWidths).length > 0) {
            var measuredHeaderWidths = tslib_1.__assign({}, this.measuredHeaderWidths);
            this.measuredHeaderWidths = {};
            this.props.measureColumnWidths(measuredHeaderWidths);
        }
    };
    HeaderRow.prototype.isColumnSelected = function (colIdx) {
        return !!this.props.selectionModel && this.props.selectionModel.isSelected({ colIdx: colIdx, colKey: this.props.cols[colIdx].dataKey, rowIdx: -1 });
    };
    HeaderRow.prototype.render = function () {
        var _this = this;
        var columnWidths = this.props.columnWidths || {};
        var headerCols = [];
        // Optionally show Select-All corner 'button'
        var showSelectAll = !!this.props.onRowHeaderCellClick && this.props.colStartIdx === 0;
        if (showSelectAll) {
            headerCols.push(React.createElement(RowHeaderCell_1.RowHeaderCell, tslib_1.__assign({}, {
                isSelected: false,
                key: "hcell",
                onRowHeaderCellClick: this.props.onRowHeaderCellClick,
                rowType: RowHeaderCell_1.RowHeaderCell.RowType.Header,
                testId: 'hcell'
            })));
        }
        for (var colIdx = this.props.colStartIdx; colIdx <= this.props.colEndIdx; colIdx++) {
            var col = this.props.cols[colIdx];
            var shouldReportWidth = !col.preferredWidth && this.props.measuredColumnWidths[col.name] === undefined;
            if (colIdx === this.state.dragIndex) {
                headerCols.push(React.createElement("span", { key: '%%dg-drag-indicator%%', className: 'drag-indicator', role: 'presentation' }));
            }
            headerCols.push(React.createElement(HeaderColumn_1.HeaderColumn, tslib_1.__assign({}, {
                col: col,
                colIdx: colIdx,
                draggable: !!this.props.onColumnReorder,
                isSelected: this.isColumnSelected(colIdx),
                key: col.name,
                minWidth: this.props.minColWidth,
                onColumnResize: this.props.onColumnResize,
                onColumnResizeFinish: this.props.onColumnResizeFinish,
                onHeaderClick: this.props.onHeaderClick,
                onHeaderContextMenu: this.props.onHeaderContextMenu,
                onHeaderDoubleClick: this.props.onHeaderDoubleClick,
                reportWidthFn: shouldReportWidth ? this.handleReportHeaderWidth : undefined,
                showVerticalGridLines: this.props.showVerticalGridLines,
                sortAscending: this.props.sortAscending,
                sorted: this.props.sortKey === col.dataKey,
                tabIndex: -1,
                width: shouldReportWidth ? undefined : columnWidths[col.name],
            })));
        }
        return (React.createElement("div", tslib_1.__assign({ "aria-rowindex": 1, className: 'tb-react-dg-hrow' }, (this.props.onColumnReorder && {
            onDragOver: function (e) {
                e.preventDefault();
                _this.setState({ dragIndex: getDragIndexFromEvent(e) });
                e.dataTransfer.dropEffect = 'move';
            },
            onDragLeave: function (e) {
                // clear the indicator if the pointer leaves the drop zone
                if (!e.currentTarget.contains(e.relatedTarget)) {
                    e.dataTransfer.dropEffect = 'none';
                    _this.setState({ dragIndex: -1 });
                }
            },
            onDragEnd: function () {
                _this.setState({ dragIndex: -1 });
            },
            onDrop: function (e) {
                var _a, _b;
                var dropIndex = getDragIndexFromEvent(e);
                _this.setState({ dragIndex: -1 });
                if (dropIndex > -1) {
                    (_b = (_a = _this.props).onColumnReorder) === null || _b === void 0 ? void 0 : _b.call(_a, e.dataTransfer.getData(HeaderColumn_1.DragDataType), dropIndex);
                }
            }
        }), { ref: this.props.headerRef, role: 'row', style: {
                height: this.props.headerHeight,
                paddingLeft: this.props.leftMargin,
                position: 'sticky',
                top: 0,
                zIndex: 1,
            } }),
            React.createElement("div", { className: typestyle_1.classes('tb-react-dg-hcols', { dragging: this.state.dragIndex > -1 }, typestyle_1.style({
                    display: 'inline-block',
                    height: '100%',
                    whiteSpace: 'nowrap',
                    $nest: {
                        '&.dragging [data-resizehandle="true"]': { display: 'none' },
                        '& > .drag-indicator': {
                            position: 'absolute',
                            width: 5,
                            background: '#EB8F50',
                            top: 0,
                            bottom: 0,
                            pointerEvents: 'none',
                            zIndex: 2,
                            marginLeft: -2,
                        }
                    }
                })) }, headerCols)));
    };
    HeaderRow.displayName = 'DataGridHeaderRow';
    return HeaderRow;
}(React.PureComponent));
exports.HeaderRow = HeaderRow;
//# sourceMappingURL=HeaderRow.js.map